export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7342.debf6c3e.jpg";